import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';

class FormRaisedButton extends Component {
    render() {
        const { action, ...props } = this.props;

        return <RaisedButton {...props} />;
    }
}

export default FormRaisedButton;



// WEBPACK FOOTER //
// ./src/UI/FormRaisedButton.js